/**
 * User Input API Client
 * Handles form submission (user input records) and retrieval.
 */

import { BaseHttpClient } from './http.client';
import { atlasApiConfig } from './config';
import type { ApiResponse, FormRecord } from '@atlas-forms/types-js';

const EP = {
  SUBMIT:   '/api/v1/atlas/form-data/submit',
  BY_FORM:  '/api/v1/atlas/form-data/by-form',
  GET:      '/api/v1/atlas/form-data/get',
  DELETE:   (id: number) => `/api/v1/atlas/form-data/${id}`,
} as const;

export class UserInputApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async submitFormData(request: { formID: string; data: Record<string, unknown>; metadata?: Record<string, unknown> }): Promise<ApiResponse<FormRecord>> {
    return this.postQuery<FormRecord>(EP.SUBMIT, request);
  }

  async listFormRecords(formID: number, request: Record<string, unknown> = {}): Promise<ApiResponse<FormRecord[]>> {
    return this.postQuery<FormRecord[]>(EP.BY_FORM, { formID, ...request });
  }

  async getFormRecord(recordId: number): Promise<ApiResponse<FormRecord>> {
    return this.postQuery<FormRecord>(EP.GET, { ID: { ID: recordId } });
  }

  async deleteFormRecord(id: number): Promise<ApiResponse<boolean>> {
    return this.delete<boolean>(EP.DELETE(id));
  }
}

export const userInputApiClient = new UserInputApiClient();
